import(/* webpackMode: "eager", webpackExports: ["ImmerInit"] */ "/home/runner/work/settlin.in/settlin.in/components/immer-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/settlin.in/settlin.in/components/search/compare/comparison-tray.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MinimizedComparisonBadge"] */ "/home/runner/work/settlin.in/settlin.in/components/search/compare/minimized-comparison-badge.tsx");
